import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#2a2620] mt-20 bg-[#080807]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <BrandMark size={64} />
          <p className="mt-5 text-sm text-[#8a7e6d] max-w-sm leading-relaxed">
            AI Visibility Intelligence. We help businesses move from being
            <em className="text-[#c9bca4]"> described</em> by AI to being
            <em className="text-[#b8963e]"> recommended</em> by AI.
          </p>
        </div>
        <div>
          <p className="overline-soft">Platform</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="/#how"   className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">How it works</a></li>
            <li><a href="/#score" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Scoring framework</a></li>
            <li><a href="/audit/new" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Run a snapshot</a></li>
          </ul>
        </div>
        <div>
          <p className="overline-soft">The AI Visibility Index™</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/research" data-testid="footer-research-hub" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Research Hub</Link></li>
            <li><Link to="/research/findings" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Findings</Link></li>
            <li><Link to="/research/teardowns" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Teardowns</Link></li>
            <li><Link to="/research/reports" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Reports</Link></li>
            <li><Link to="/research/case-studies" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Case Studies</Link></li>
            <li><Link to="/research/methodology" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Methodology</Link></li>
            <li><Link to="/llm" data-testid="footer-llm-info" className="text-[#c9bca4] hover:text-[#b8963e] transition-colors">Canonical entity file</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline-soft">Contact</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li className="text-[#c9bca4]">theentityagency.com</li>
            <li className="text-[#c9bca4]">contact@theentityagency.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2a2620] py-5 px-6 sm:px-8 text-[10px] tracking-[0.2em] font-mono-eav uppercase text-[#5e5448] text-center">
        © {new Date().getFullYear()} The Entity Agency · AI Visibility Snapshot™ · Confidential
      </div>
    </footer>
  );
}
